import { render, staticRenderFns } from "./addDescriptionDialog.vue?vue&type=template&id=39a12007&scoped=true"
import script from "./addDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./addDescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a12007",
  null
  
)

export default component.exports